(function (context, namedBreakpoints) {
    console.info('it is considered a bad practive to use container-query.js, please migrate to native container queries, if possible, this script might be removed in the future');
    function replaceSpecialTokens(code) {
        const replacements = {
            ' lt ': ' < ',
            ' lte ': ' <= ',
            ' eq ': ' == ',
            ' neq ': ' != ',
            ' gte ': ' >= ',
            ' gt ': ' > ',
            ' and ': ' && ',
            ' or ': ' || ',
        };
        Object.getOwnPropertyNames(replacements).forEach(token => {
            code = code.replaceAll(token, replacements[token]);
        });
        return code;
    }
    async function parse(node) {
        let target;
        let code;
        if (node instanceof HTMLScriptElement) {
            code = node.textContent;
            if (node.dataset.target) {
                target = document.getElementById(node.dataset.target);
            } else {
                target = node.parentElement;
            }
        } else {
            target = node;
            code = node.getAttribute('data-cq').toString();
            code = replaceSpecialTokens(code);
        }
        if (target && code) {
            function attr(assertion, attrName, thenValue, elseValue) {
                const value = assertion ? thenValue : elseValue;
                if (value === null || value === undefined) {
                    target.removeAttribute(attrName);
                } else {
                    target.setAttribute(attrName, value);
                }
                return true;
            }
            function toggleClass(assertion, className) {
                target.classList[assertion ? 'add' : 'remove'](className);
                return true;
            }
            function breakpoints() {
                const width = target.parentElement.offsetWidth;
                const cl = target.classList;
                const matches = {};
                Object.getOwnPropertyNames(namedBreakpoints).forEach(breakpointName => {
                    matches[breakpointName] = width >= namedBreakpoints[breakpointName].numberValue;
                });
                Object.getOwnPropertyNames(namedBreakpoints).forEach(breakpointName => {
                    if (matches[breakpointName]) {
                        cl.add(`container-${breakpointName}-up`);
                        cl.remove(`container-until-${breakpointName}`);
                    } else {
                        cl.remove(`container-${breakpointName}-up`);
                        cl.add(`container-until-${breakpointName}`);
                    }
                });
                return true;
            }
            let callback;
            eval(`callback = function(width, height) {
                ${Object.getOwnPropertyNames(namedBreakpoints).map(breakpointName => `
                const ${breakpointName} = ${namedBreakpoints[breakpointName].numberValue};
                `).join('\n')}
                ${code}
            }`);
            target['containerQueryCallback'] = callback;
            new ResizeObserver((entries) => {
                callback(entries[0].target.offsetWidth, entries[0].target.offsetHeight);
            }).observe(target.parentElement);
            callback(target.parentElement.offsetWidth, target.parentElement.offsetHeight);
        }
        return true;
    }

    let processed = false;
    function process() {
        processed = true;
        Promise.all(
            Array.from(context.querySelectorAll(':is(script[type="container-query"],*[data-cq]):not([data-cq-parsed])')).map(async node => {
                node.setAttribute('data-cq-parsed', 'true');
                let target;
                if (node instanceof HTMLScriptElement) {
                    if (node.dataset.target) {
                        target = document.getElementById(node.dataset.target);
                    } else {
                        target = node.parentElement;
                    }
                } else {
                    target = node;
                }
                if ('containerQueryCallback' in target) {
                    resolve();
                } else {
                    await parse(node);
                }
                return true;
            })
        );
    }
    const observer = new MutationObserver(process);
    observer.observe(context, {
        childList: true,
        subtree: true,
    });
    if (processed === false) {
        process();
    }
})(document, window['namedBreakpoints'] ?? {});
